module.exports = __webpack_public_path__ + "static/media/bg.02f08577.png";